import scrollLock from 'scroll-lock';
import { gsap } from 'gsap';
import barba from '@barba/core';
import { ecommerce } from './Ecommerce';

export default class Menu {
	constructor(elm) {
		this.elm = elm;

		this.isMobile = window.matchMedia('(max-width:991px)');
		this.isOpen = false;

		this.container = document.querySelector('[data-barba="container"]');
		this.blurLayer = document.querySelector('[data-blur-layer]');

		this.elm.addEventListener('mouseenter', () => {
			if (!this.isMobile.matches) {
				this.blurLayer.classList.add('blur-layer--blurred');
			}
		});

		this.elm.addEventListener('mouseleave', () => {
			if (!this.isMobile.matches && !ecommerce.isCartOpen) {
				this.blurLayer.classList.remove('blur-layer--blurred');
			}
		});

		this.initialised = false;

		this.init(this.container);
	}

	init(container) {
		this.container = container;

		if (this.initialised) {
			this.dummy = this.container.querySelector('[data-dummy-menu]');
			this.elm.innerHTML = this.dummy.innerHTML;
			ecommerce.updateCartButton();
		}

		this.toggleButton = this.elm.querySelector('[data-toggle-button]');
		if (this.toggleButton) {
			this.toggleButton.addEventListener('click', () => {
				this.toggle();
			});

			this.toggleDefaultText = this.toggleButton.innerHTML;
			this.toggleActiveText = this.toggleButton.dataset.activeText;
		}

		this.backButton = this.elm.querySelector('[data-back-button');
		if (this.backButton) {
			this.backButton.addEventListener('click', (e) => {
				if (barba.history.previous&&(barba.history.previous.ns=='single-wps_products'||barba.history.previous.ns=='template-index')) {
					e.preventDefault();
					barba.go(barba.history.previous.url);
				}
			});
		}

		this.shopAsLink = this.elm.querySelector('[data-shop-as-link]');
		if (this.shopAsLink) {
			this.shopAsLink.addEventListener('click', (e) => {
				this.shopAsLink.classList.add('is-clicked');
			});
		}

		const shopSelects = this.elm.querySelectorAll('[data-shop-selection]');
		shopSelects.forEach((shopSelect) => {
			const trigger = shopSelect.querySelector('[data-shop-selection-button]');
			trigger.addEventListener('click', () => {
				shopSelect.classList.toggle('is-open');
			});
		});

		if(!this.initialised) {
			let mm = gsap.matchMedia();
			mm.add(
				{
					isMobile: `(max-width: 991px)`,
					isDesktop: `(min-width: 992px)`,
					reduceMotion: '(prefers-reduced-motion: reduce)',
				}, (context) => {
					this.context = context;
					this.render(true);
				}
			);
		}

		this.initialised = true;
	}

	toggle() {
		if(this.isOpen) {
			barba.logoLayerDirector.returnToCenter(0.8, true);
		}

		this.isOpen ? this.close(true) : this.open();
	}

	open() {
		this.isOpen = true;
		this.render();
	}

	close() {
		this.isOpen = false;
		this.render();
	}

	render() {
		const context = this.context;
		let { isMobile, isDesktop, reduceMotion } = context.conditions;

		let duration = context.isReverted ? 0 : 0.8;

		if(this.isOpen) { // OPEN

			if (isMobile) { // Mobile
				document.dispatchEvent(new CustomEvent('disable-scroll'));
				this.elm.classList.add('is-open');
				this.blurLayer.classList.add('blur-layer--blurred');

				gsap.to(this.elm, {
					translateY: 0,
					duration: duration,
					ease: 'power2.inOut'
				});

				gsap.to(this.container, {
					top: this.elm.getBoundingClientRect().height, // TranslateY gives problems with sticky/fixed child elements
					duration: duration,
					ease: 'power2.inOut'
				});

				if (this.toggleButton) {
					this.toggleButton.setAttribute('aria-label', this.toggleActiveText);
					this.toggleButton.innerHTML = '&nbsp;' + this.toggleActiveText;
				}
				barba.logoLayerDirector.makeRoomForMenu(this);
			} else { // Desktop
				gsap.set(this.elm, {
					translateY: 0
				});

				gsap.set(this.container, {
					top: 0
				});

				document.dispatchEvent(new CustomEvent('enable-scroll'));
				this.elm.classList.remove('is-open');
				this.blurLayer.classList.remove('blur-layer--blurred');
			}

		} else { // CLOSE

			if (isMobile) { // Mobile

				gsap.to(this.elm, {
					translateY: '-100%',
					duration: duration,
					ease: 'power2.inOut',
					onStart: () => {
						this.blurLayer.classList.remove('blur-layer--blurred');
						this.elm.classList.remove('is-open');
						if (this.toggleButton) {
							this.toggleButton.setAttribute('aria-label', this.toggleDefaultText);
							this.toggleButton.innerHTML = this.toggleDefaultText;
						}
					},
					onComplete: () => {
						const scrollLockState = scrollLock.getScrollState();
						if(scrollLockState) {
							document.dispatchEvent(new CustomEvent('enable-scroll'));
						}
					},
				});

				gsap.to(this.container, {
					top: 0, // TranslateY gives problems with sticky/fixed child elements
					duration: duration,
					ease: 'power2.inOut',
					onComplete: () => {
						this.container.style.removeProperty('transform');
					}
				});
			} else { // Desktop
				gsap.set(this.elm, {
					translateY: 0
				});

				gsap.set(this.container, {
					top: 0
				});
			}

		}
	}

	update(container) {
		this.init(container);
	}
}
